<template>
	<div class="d-flex">
		<div class="card ml-4 col-2" style="margin-top: 50px; max-height: 500px;">
			<div class="mt-2 card-body">
				<b-form-input class="mb-2" v-model="searchFilter.all" placeholder="Alles"
											@keypress.enter="inventoryQuery()"></b-form-input>
				<b-form-input class="mb-2" v-model="searchFilter.ean" placeholder="EAN"
											@keypress.enter="inventoryQuery()"></b-form-input>
				<b-form-input class="mb-2" v-model="searchFilter.asin" placeholder="ASIN"
											@keypress.enter="inventoryQuery()"></b-form-input>
				<b-form-input class="mb-2" v-model="searchFilter.name" placeholder="Name"
											@keypress.enter="inventoryQuery()"></b-form-input>
				<multi-select
						class="mb-2 multiselect"
						:value="selectedVendors"
						@input="selectedVendors = $event"
						:options="vendorOptions"
						:multiple="true"
						label="text"
						track-by="value"
						:close-on-select="false"
						:searchable="false"
						:select-label="''"
						:deselect-label="''"
						:selected-label="'✓'"
						placeholder="Suche"
						style="height: calc(1.5em + 0.5rem + 2px);"
				>
					<template #selection="{ search, values, isOpen }">
						<div class=" align-items-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
							<span
									v-for="option in values"
									:key="option.value"
									class="p-1 position-relative"
									style="font-size: 1rem; font-weight: normal !important;"
							>
								{{ option.text}}
							</span>
							<input
									v-if="isOpen"
									type="text"
									class="border-0 shadow-none"
									style="min-width: 100px; background: transparent;"
							/>
						</div>
					</template>
					<template #singleLabel>
						<span class="d-flex align-items-center"></span>
					</template>
					<template #placeholder>
						<span>Händler</span>
					</template>
					<template v-slot:caret="{ toggle }">
						<div class="multiselect__select" @mousedown.prevent.stop="toggle">
							<span class="d-flex align-items-center justify-content-center">
							</span>
						</div>
					</template>
					<template v-slot:option="{ option }">
						{{ option.text }}
					</template>
				</multi-select>
					<multi-select
							class="mb-2 multiselect"
							:value="selectedCategories"
							@input="selectedCategories = $event"
							:options="categoryOptions"
							:multiple="true"
							label="text"
							track-by="value"
							:close-on-select="false"
							:searchable="false"
							:select-label="''"
							:deselect-label="''"
							:selected-label="'✓'"
							placeholder="Suche"
							style="height: calc(1.5em + 0.5rem + 2px);"
					>
					<template #selection="{ search, values, isOpen }">
						<div class=" align-items-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
							<span
									v-for="option in values"
									:key="option.value"
									class="p-1 position-relative"
									style="font-size: 1rem; font-weight: normal !important;"
							>
								{{ option.text}}
							</span>
							<input
									v-if="isOpen"
									type="text"
									class="border-0 shadow-none"
									style="min-width: 100px; background: transparent;"
							/>
						</div>
					</template>
					<template #singleLabel>
						<span class="d-flex align-items-center"></span>
					</template>
					<template #placeholder>
						<span>Kategorien</span>
					</template>
					<template v-slot:caret="{ toggle }">
						<div class="multiselect__select" @mousedown.prevent.stop="toggle">
							<span class="d-flex align-items-center justify-content-center">
							</span>
						</div>
					</template>
					<template v-slot:option="{ option }">
						{{ option.text }}
					</template>
				</multi-select>
				<b-form-checkbox class="mb-2 text-center" v-model="searchFilter.hasStock" switch>Hat Bestand</b-form-checkbox>
				<div class="text-center">
					<b-btn class="mr-1" @click="inventoryQuery()">Filtern</b-btn>
					<b-btn class="" @click="resetFilters()">Reset Filter</b-btn>
				</div>
				<hr>
				<div class="text-center">
					<b-btn variant="primary" :disabled="queryInProgress" @click="checkMaterialCount()"><i
							class="bi bi-file-earmark-spreadsheet mr-2" style="font-size: 1.25em;"></i> Export
						<b-spinner v-if="exportQueryInProgress" small label="Spinning"/>
					</b-btn>
				</div>
			</div>
		</div>
		<div class="card ml-3 col-9" style="margin-top: 50px;">
			<div class="card-body w-100">
				<b-row style="justify-content: space-between;">
					<h3 class="ml-2">Materials</h3>
					<div class="d-flex">
						<span class="mr-2 mt-2">Treffer: {{ totalResults }}</span>
						<b-pagination class="mr-2"
													v-model="currentPage"
													:total-rows="totalResults"
													:per-page="perPage"
						></b-pagination>
						<div>
							<b-dropdown class="m-auto"
													size="md" right
													variant="outline-primary"
													:text="perPage.toString()"
							>
								<b-dropdown-item @click="() => { this.perPage = '25' }">25</b-dropdown-item>
								<b-dropdown-item @click="() => { this.perPage = '50' }">50</b-dropdown-item>
								<b-dropdown-item @click="() => { this.perPage = '100' }">100</b-dropdown-item>
							</b-dropdown>
						</div>
					</div>
				</b-row>
				<b-overlay :show="queryInProgress" rounded="sm">
					<b-table
							hover small
							:items="materials"
							:fields="fields"
							class="w-100"
					>
						<template #cell(ean)="row">
                            <span v-if="row.item.ean !== '-'">
                                <b-link :href="'material/'+row.item.id+'/edit'">{{ row.item.ean }}</b-link>
                            </span>
							<span v-else>
                                {{ row.item.ean }}
                            </span>
						</template>
						<template #cell(category)="row">
							<div style="min-width: 100px;">{{ getCategoryName(row.item?.product?.category) }}</div>
						</template>
					</b-table>
				</b-overlay>
			</div>
		</div>
		<b-modal v-model="showModal" @ok="exportMaterialsToXLSX()">Die Anzahl an Materials die Exportiert werden sollen,
			überseigt {{ exportWarningLimit }}.<br>
			Möchten sie trotzdem fortfahren?
		</b-modal>
		<modal-error-component v-model="modalError"/>
	</div>
</template>
<script>
import {useUserPreferenceStore} from '../stores/UserPreferenceStore';
import {useOffsetQueryStore} from '../stores/OffsetQueryStore';
import ModalErrorComponent from './ModalErrorComponent.vue';


export default {
	components: {ModalErrorComponent},
	setup() {
		const userPreferenceStore = useUserPreferenceStore();
		const offsetQueryStore = useOffsetQueryStore();
		return {userPreferenceStore, offsetQueryStore}
	},
	props: {
		productCategories: {
			type: Array,
			required: false,
		}
	},
	data() {
		return {
			materials: [],
			vendorOptions: [],
			fields: [
				{key: "id", label: "#", sortable: true},
				{key: "ean", label: "EAN"},
				{key: "product.name", label: "Name"},
				{key: "category", label: "Kategorie"},
			],
			categoryOptions: [],
			selectedCategories: [],
			selectedVendors:  [],
			searchFilter: {
				all: null,
				ean: null,
				asin: null,
				vendors: [],
				categories: [],
				name: null,
				hasStock: false,
				limit: null,
				offset: null,
			},
			perPage: 25,
			currentPage: 1,
			totalResults: null,
			queryInProgress: false,
			showModal: false,
			exportQueryInProgress: false,
			exportWarningLimit: 100000,
			modalError: {
				show: false,
				message: 'unpopulated',
				error: 'unpopulated',
				title: 'unpopulated'
			},
		}
	},
	computed: {},
	watch: {
		perPage(newVal) {
			console.log('perPage ' + newVal);
			this.userPreferenceStore.inventory.perPage = newVal;
			if (this.queryInProgress === false) {

				this.inventoryQuery();
			}
		},
		currentPage(newVal) {
			console.log('currentPage ' + newVal);
			this.userPreferenceStore.inventory.currentPage = newVal
			if (this.queryInProgress === false) {

				this.inventoryQuery();
			}
		},
		selectedCategories(newVal) {
			this.searchFilter.categories = newVal?.map(cat => cat.value);
		},
		selectedVendors(newVal) {
			this.searchFilter.vendors = newVal?.map(cat => cat.value);
		},
	},
	methods: {
		exportMaterialsToXLSX() {
			let currentDate = moment().format("DD.MM.YYYY");

			this.searchFilter.limit = null
			this.searchFilter.offset = 0;
			this.exportQueryInProgress = true;
			this.queryInProgress = true;
			this.offsetQueryStore.inventoryExportQuery(this.searchFilter)
					.then(res => {
						let exportMaterials = res;
						// console.log(exportMaterials);
						this.exportQueryInProgress = false;
						this.queryInProgress = false;

						let mappedMaterials = exportMaterials.map(material => {
							return {
								Id: material.id,
								EAN: material.ean,
								Name: material.product.name,
								Kategorie: this.getCategoryName(material.product.category)
							}
						});
						Vue.nextTick().then(() => {
							const ws = XLSX.utils.json_to_sheet(mappedMaterials);
							const wb = XLSX.utils.book_new();
							XLSX.utils.book_append_sheet(wb, ws, "Materials");
							XLSX.writeFile(wb, "InventorySuche-" + currentDate + ".xlsx");
						})
					})
					.catch(err => {
						console.log(err);
						this.exportQueryInProgress = false;
						this.queryInProgress = false;
						this.modalError = {
							show: true,
							message: 'Ein Fehler ist augetreten:',
							error: err,
							title: 'Excel Export'
						}
					});
		},
		getCategoryName(categoryId) {
			let category = this.categoryOptions.find(cat => cat.value === categoryId);
			return category?.text;
		},
		checkMaterialCount() {
			if (this.materials.length > this.exportWarningLimit) {
				this.showModal = true;
			} else {
				this.exportMaterialsToXLSX();
			}
		},
		resetFilters() {
			this.searchFilter.all = null;
			this.searchFilter.ean = null;
			this.searchFilter.asin = null;
			this.searchFilter.name = null;
			this.searchFilter.vendors = [];
			this.searchFilter.categories = [];
			this.selectedVendors = [];
			this.selectedCategories = [];
			this.searchFilter.hasStock = false;

		},
		setCurrentPreferences() {
			this.userPreferenceStore.inventory.perPage = this.perPage;
			this.userPreferenceStore.inventory.currentPage = this.currentPage;
			this.userPreferenceStore.inventory.searchFilter = this.searchFilter;
		},
		inventoryQuery() {
			this.setCurrentPreferences();

			this.searchFilter.limit = this.perPage;
			this.searchFilter.offset = ((this.currentPage - 1) * this.perPage);
			this.queryInProgress = true;
			this.offsetQueryStore.inventoryQuery(this.searchFilter)
					.then(res => {
						this.materials = res[0];
						this.totalResults = res[1];
						this.queryInProgress = false;
					})
					.catch(err => {
						console.log(err);
						this.modalError = {
							show: true,
							message: 'Ein Fehler ist aufgetreten:',
							error: err,
							title: 'Material Request'
						}
						this.queryInProgress = false;
					});
		},
	},
	created() {
		this.categoryOptions = Object.values(this.productCategories).map(category => {
			return {
				value: category.categoryId,
				text: category.uiName
			}
		});

		this.queryInProgress = true;
		axios.get("vendor/all_names").then(vendorRes => {
			this.vendorOptions = vendorRes.data.map(vendor => {
				return {
					value: vendor.id,
					text: vendor.name
				}
			});
			if (this.userPreferenceStore.inventory?.searchFilter !== null &&
					JSON.stringify(this.userPreferenceStore.inventory?.searchFilter) !== JSON.stringify(this.searchFilter)) {
				this.searchFilter = this.userPreferenceStore.inventory.searchFilter;
				this.selectedCategories = this.categoryOptions.filter(cat => this.searchFilter.categories.includes(cat.value));
				this.selectedVendors = this.vendorOptions.filter(cat => this.searchFilter.vendors.includes(cat.value));
			}
			this.perPage = this.userPreferenceStore.inventory.perPage ?? this.perPage;
			this.currentPage = this.userPreferenceStore.inventory.currentPage ?? this.currentPage;

			this.searchFilter.offset = ((this.currentPage - 1) * this.perPage)
			this.searchFilter.limit = this.perPage;
			this.offsetQueryStore.inventoryQuery(this.searchFilter)
					.then(storeRes => {
						this.materials = storeRes[0];
						this.totalResults = storeRes[1];
						this.queryInProgress = false;
					})
					.catch(storeErr => {
						this.modalError = {
							show: true,
							message: 'Ein Fehler ist augetreten:',
							error: storeErr,
							title: 'Material Request'
						}
						this.queryInProgress = false;
					})
		}).catch(vendorErr => {
			this.modalError = {
				show: true,
				message: 'Ein Fehler ist augetreten:',
				error: vendorErr,
				title: 'Vendor Request'
			}
			this.queryInProgress = false;
		})

	}
}
</script>